import { sm2 } from 'sm-crypto'

sm2.encrypt = function (str, pubk) {
  return '04' + sm2.doEncrypt(str, pubk, 1)
}

export default sm2
